export function compareSrmVersions(left, right) {
  const parse = value => String(value ?? "")
    .trim()
    .replace(/^v/i, "")
    .split("-")[0]
    .split(".")
    .map(part => Number.parseInt(part, 10) || 0);

  const a = parse(left);
  const b = parse(right);
  const length = Math.max(a.length, b.length);
  for (let index = 0; index < length; index += 1) {
    const difference = (a[index] || 0) - (b[index] || 0);
    if (difference !== 0) return Math.sign(difference);
  }
  return 0;
}

export function isSrmUpdateNewer(update, currentConfig) {
  if (!update || !currentConfig) return false;

  if (update.version) {
    const versionComparison = compareSrmVersions(update.version, currentConfig.version);
    if (versionComparison !== 0) return versionComparison > 0;
  }

  const incomingBuild = Number(update.build_no);
  const currentBuild = Number(currentConfig.build_no);
  return Number.isFinite(incomingBuild)
    && Number.isFinite(currentBuild)
    && incomingBuild > currentBuild;
}

export function srmUpdateIdentity(update) {
  return [update?.version || "", update?.build_no ?? "", update?.published_at || ""].join("|");
}
